import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  apiGetBranding,
  apiUploadLogo,
  apiUploadLogoDark,
  apiDeleteLogo,
  apiDeleteLogoDark,
  apiUpdateOpportunitiesLabel,
} from "@api/branding";

export function useBranding() {
  return useQuery({
    queryKey: ["branding"],
    queryFn: apiGetBranding,
  });
}

export function useUploadLogo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiUploadLogo,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["branding"] }),
  });
}

export function useUploadLogoDark() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiUploadLogoDark,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["branding"] }),
  });
}

export function useDeleteLogo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiDeleteLogo,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["branding"] }),
  });
}

export function useDeleteLogoDark() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiDeleteLogoDark,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["branding"] }),
  });
}

export function useUpdateOpportunitiesLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiUpdateOpportunitiesLabel,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["branding"] }),
  });
}
